// extracted by mini-css-extract-plugin
export default {"element":"UploadUserPhotoModal_element__CRfPI"};